import React, { lazy } from 'react';
import ProtectedRoute from '@/router/components/ProtectedRoute';
import { ROUTES } from '@/constants/routes';

// Lazy loaded components
const ReleaseQADashboard = lazy(
  () => import('@/pages/reports/release-qa-dashboard'),
);
const RegressionDashboard = lazy(
  () => import('@/pages/reports/regression-dashboard'),
);

/**
 * Report-related routes configuration
 */
export const reportRoutes = [
  {
    path: ROUTES.RELEASE_QA_DASHBOARD,
    element: <ProtectedRoute component={ReleaseQADashboard} />,
  },
  {
    path: ROUTES.REGRESSION_DASHBOARD,
    element: <ProtectedRoute component={RegressionDashboard} />,
  },
];
